import { gql, TypedDocumentNode } from "@apollo/client";
import { GetProfileQuery, GetProfileQueryVariables } from "generated/graphql";

// QUERIES

export const PROFILE_QUERY: TypedDocumentNode<
  GetProfileQuery,
  GetProfileQueryVariables
> = gql`
  query GetProfile {
    me {
      id
      lastName
      firstName
      username: activeDirectoryId
      profilePicture(size: 96)
      phone
      email
      activeDirectoryId
      isContentAdmin
      isWebsiteEditor
    }
  }
`;
